import {alias, createModelSchema, list} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {ProductModel} from "../../product/ProductModel";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";

export class SmartOfferBundleMagicalCinema extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.MAGICAL_CINEMA);

        this._products = [];
        this._rewardTrack = null;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    get rewardTrack() {
        return this._rewardTrack;
    }

    set rewardTrack(value) {
        this._rewardTrack = value;
    }

    valid() {

        if (!this.products || this.products.length === 0) {
            return false;
        }

        if (this.products.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.rewardTrack && !this.rewardTrack.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (super.empty()) {
            return true;
        }

        return !this.products || this.products.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleMagicalCinema());
        } else if (target instanceof SmartOfferBundleMagicalCinema) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleMagicalCinema, {
    _products: alias("products", list(ProductModel.schema())),
    _rewardTrack: alias("reward_track", RewardTrack.schema())
});
